module.exports = __webpack_public_path__ + "img/reason_03@2x.13b15cef.png";